import axios from "axios";

const axiosInstance = axios.create({
  // Base URL Or POS Demo
   baseURL: "https://posdemobackend.softwisesol.com",

  /* The line `const COMPANYHEADER = "Qureshi Electronics"` is declaring a constant variable named
  `COMPANYHEADER` and assigning it the string value "Qureshi Electronics". This constant represents
  the name of a company or business entity in the code. */
  // baseURL: 'http://localhost:4500',
  withCredentials: true,
});
export default axiosInstance;
